export default "__VITE_ASSET__DEPYDmjU__"